import { Box } from '@mantine/core';
import { AssistantChatView } from '../chat/AssistantChatView';

/**
 * Dock-панель ассистента (правая боковая панель приложения).
 * Тонкая обёртка: содержимое и состояние — в AssistantChatView и его контроллерах,
 * поэтому закрытие/открытие панели не прерывает стрим и не теряет диалог.
 */
export function AssistantDockPanel() {
  return (
    <Box p='xs' h='100%'>
      <AssistantChatView />
    </Box>
  );
}
